module.exports = __webpack_public_path__ + "static/media/20 - Unknown Mortal Orchestra - Hunnybee.159da605.mp3";